import { api } from '../api';
import type {
  ClientHistoryFilters,
  ClientHistoryResult,
  ClientHistoryScope,
  CompanyNote,
  CompanyNotePayload,
} from './types';

export function clientHistoryPath(scope: ClientHistoryScope, entityId: string, filters: ClientHistoryFilters): string {
  const search = new URLSearchParams();
  const values: Array<[keyof ClientHistoryFilters, string | number | undefined]> = [
    ['kind', filters.kind],
    ['direction', filters.direction],
    ['status', filters.status],
    ['contactId', filters.contactId],
    ['operatorUserId', filters.operatorUserId],
    ['dateFrom', filters.dateFrom],
    ['dateTo', filters.dateTo],
    ['page', filters.page || 1],
    ['pageSize', filters.pageSize || 20],
  ];
  values.forEach(([key, value]) => {
    if (value !== undefined && value !== '') search.set(key, String(value));
  });
  const resource = scope === 'company' ? 'companies' : 'contacts';
  return `/client-history/${resource}/${encodeURIComponent(entityId)}?${search.toString()}`;
}

export function callClientLinkPayload(companyId: string, contactId?: string) {
  return {
    companyId,
    ...(contactId ? { contactId } : {}),
  };
}

export const clientHistoryApi = {
  history(scope: ClientHistoryScope, entityId: string, filters: ClientHistoryFilters) {
    return api<ClientHistoryResult>(clientHistoryPath(scope, entityId, filters));
  },
  createNote(companyId: string, payload: CompanyNotePayload) {
    return api<CompanyNote>(`/client-history/companies/${companyId}/notes`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
  updateNote(companyId: string, noteId: string, payload: CompanyNotePayload) {
    return api<CompanyNote>(`/client-history/companies/${companyId}/notes/${noteId}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
  },
  deleteNote(companyId: string, noteId: string) {
    return api<{ id: string; deleted: true }>(`/client-history/companies/${companyId}/notes/${noteId}`, {
      method: 'DELETE',
    });
  },
  linkCallClient(callId: string, companyId: string, contactId?: string) {
    return api(`/client-history/calls/${callId}/client`, {
      method: 'PATCH',
      body: JSON.stringify(callClientLinkPayload(companyId, contactId)),
    });
  },
};
